<span *ngFor="let role of roles" class="badge badge-pill badge-info p-2 m-1">
  {{ role }}
</span>
